<template>
  <main class="cs-v2-page bg-light min-vh-100">
    <div class="container-fluid py-4">
      <!-- Cabeçalho da página -->
      <div class="cs-v2-header d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 class="cs-v2-title h4 mb-1">Central de Tickets</h2>
          <p class="text-muted small mb-0">Gestão aprimorada de atendimentos e serviços</p>
        </div>
        <button class="btn btn-success px-4 py-2 shadow-sm" @click="openCreateModal">
          <i class="fas fa-plus me-2"></i> Novo Ticket
        </button>
      </div>

      <!-- Filtros -->
      <ticket-filters
        :users="users"
        :customers="customers"
        :tasks="tasks"
        :task-types="taskTypes"
        :services-status="servicesStatus"
        @filter="applyFilters"
        @clear="clearFilters"
      />

      <!-- Tabela -->
      <ticket-table
        :tickets="customerServices"
        :loading="loading"
        @edit="openEditModal"
        @delete="destroy"
        @re-open="reOpen"
        @view-activities="tasksMadeExpenses"
      />

      <!-- Modal de criação/edição -->
      <ticket-form-modal
        ref="ticketModal"
        :users="users"
        :customers="customers"
        :tasks="tasks"
        :task-types="taskTypes"
        @saved="onSaved"
      />

      <tasks-made-and-expenses-modal />
    </div>
  </main>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import TicketFilters from '../components/CustomerServiceV2/TicketFilters.vue'
import TicketTable from '../components/CustomerServiceV2/TicketTable.vue'
import TicketFormModal from '../components/CustomerServiceV2/TicketFormModal.vue'
import TasksMadeAndExpensesModal from "../components/TasksMadeAndExpensesModal"

export default {
  name: 'CustomerServiceV2',
  components: {
    TicketFilters,
    TicketTable,
    TicketFormModal,
    TasksMadeAndExpensesModal
  },
  data() {
    return {
      eventHub: new Vue(),
      customerServices: [],
      users: [],
      customers: [],
      tasks: [],
      taskTypes: [],
      servicesStatus: [
        { id: 'pending', name: 'Pendente' },
        { id: 'in_progress', name: 'Em Andamento' },
        { id: 'completed', name: 'Finalizado' },
      ],
      loading: false,
      stringFilters: null,
      loadStringFilters: false,
    }
  },
  provide() {
    return {
      eventHub: this.eventHub
    }
  },
  mounted() {
    this.loadOptions()
    this.loadCustomerServices()
  },
  methods: {
    async loadOptions() {
      try {
        const [tasks, taskTypes, customers, users] = await Promise.all([
          axios.get('/api/tasks'),
          axios.get('/api/task_types'),
          axios.get('/api/customers'),
          axios.get('/api/users')
        ])
        this.tasks = tasks.data
        this.taskTypes = taskTypes.data.data
        this.customers = customers.data.data
        this.users = users.data.data
      } catch (error) {
        console.error("Erro ao carregar opções:", error)
      }
    },
    async loadCustomerServices() {
      this.loading = true
      try {
        if (!this.loadStringFilters) {
          const today = new Date()
          const startDate = new Date()
          startDate.setDate(today.getDate() - 30)
          this.stringFilters = `startDate=${this.formatDate(startDate)}&endDate=${this.formatDate(today)}`
        }
        const { data } = await axios.get(`/api/customer-service?${this.stringFilters}`)
        this.customerServices = data.data
      } catch (error) {
        console.error("Erro ao carregar tickets:", error)
        this.$toast.error("Erro ao carregar lista de tickets.")
      } finally {
        this.loading = false
      }
    },
    applyFilters(filters) {
      let queryParams = {
        startDate: filters.startDate ? this.convertBrToIso(filters.startDate) : null,
        endDate: filters.endDate ? this.convertBrToIso(filters.endDate) : null,
        userId: filters.user,
        customer: filters.customer,
        task: filters.task,
        taskType: filters.taskType,
        status: filters.status,
        note: filters.note
      }

      let filterString = ''
      for (let key in queryParams) {
        if (queryParams[key] !== null && queryParams[key] !== '') {
          filterString += `${key}=${queryParams[key]}&`
        }
      }
      this.stringFilters = filterString.substring(0, filterString.length - 1)
      this.loadStringFilters = true
      this.loadCustomerServices()
    },
    clearFilters() {
      this.stringFilters = ''
      this.loadStringFilters = false
      this.loadCustomerServices()
    },
    openCreateModal() {
      this.$refs.ticketModal.open()
    },
    openEditModal(ticket) {
      this.$refs.ticketModal.open(ticket)
    },
    onSaved() {
      this.loadCustomerServices()
    },
    destroy(id) {
      this.$confirm({
        message: `Tem certeza que deseja excluir o Ticket #${id}?`,
        button: { no: 'Não', yes: 'Sim' },
        callback: confirm => {
          if (confirm) {
            axios.delete(`/api/customer-service/${id}`)
              .then(() => {
                this.$toast.success("Ticket excluído com sucesso!")
                this.loadCustomerServices()
              })
              .catch(() => {
                this.$toast.error("Erro ao excluir ticket.")
              })
          }
        }
      })
    },
    reOpen(id) {
      this.$confirm({
        message: `Deseja realmente reabrir o Ticket #${id}?`,
        button: { no: 'Não', yes: 'Sim' },
        callback: confirm => {
          if (confirm) {
            axios.patch(`/api/customer-service/${id}/re-open`)
              .then(() => {
                this.$toast.success("Ticket reaberto com sucesso!")
                this.loadCustomerServices()
              })
              .catch(() => {
                this.$toast.error("Erro ao reabrir ticket.")
              })
          }
        }
      })
    },
    tasksMadeExpenses(ticket) {
      this.eventHub.$emit('tasks-made-expenses-modal', ticket)
    },
    formatDate(date) {
      return (date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2))
    },
    convertBrToIso(dateStr) {
      // DD/MM/YYYY -> YYYY-MM-DD
      const parts = dateStr.split('/')
      if (parts.length === 3) {
        return `${parts[2]}-${parts[1]}-${parts[0]}`
      }
      return dateStr
    }
  }
}
</script>

<style scoped lang="sass">
.cs-v2-page
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)
  min-height: 100vh
  padding: 24px

.cs-v2-header
  display: flex
  justify-content: space-between
  align-items: center
  margin-bottom: 24px
  padding-bottom: 16px
  border-bottom: 1px solid rgba(0,0,0,0.05)

.cs-v2-title
  margin: 0
  font-weight: 800
  letter-spacing: -0.5px
  color: #2d3436
  font-size: 1.75rem

.cs-v2-subtitle
  color: #636e72
  font-size: 0.9rem
  margin-top: 4px

.btn-success
  background: linear-gradient(135deg, #00b894 0%, #00a8ff 100%)
  border: none
  padding: 10px 24px
  font-weight: 600
  border-radius: 10px
  box-shadow: 0 4px 15px rgba(0, 184, 148, 0.3)
  transition: all 0.3s ease

  &:hover
    transform: translateY(-2px)
    box-shadow: 0 6px 20px rgba(0, 184, 148, 0.4)
    background: linear-gradient(135deg, #00d3a9 0%, #34b7ff 100%)

.container-fluid
  max-width: 1400px
</style>
